import parse from 'csv-parse';

// Detects the TEAL "YYYY TELPAS Composite Scores - {district}.csv" rollup: a CSV whose header
// has a "Campus #" column and a "... TELPAS Composite Score ..." column.
const isTelpasComposite = (file) =>
  new Promise((resolve) => {
    if (file.type != 'application/vnd.ms-excel' && file.type != 'text/csv') {
      resolve({ isValid: false });
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      parse(reader.result, {}, (err, output) => {
        if (err || !output || !output.length) {
          resolve({ isValid: false });
          return;
        }
        const header = (output[0] || []).map((h) => String(h).trim());
        const hasCampus = header.some((h) => h.toLowerCase() === 'campus #');
        const scoreCol = header.find((h) => /telpas composite score/i.test(h));
        if (!hasCampus || !scoreCol) {
          resolve({ isValid: false });
          return;
        }
        const yearMatch = scoreCol.match(/\d{4}/);
        resolve({ isValid: true, assessmentYear: yearMatch ? yearMatch[0] : null });
      });
    };
    reader.readAsText(file);
  });

export default isTelpasComposite;
